import React, { Component } from 'react'
import SimpleModal from "../../common/components/simple-modal";
import TagGuestsStage from "../../tag-guests/components/tag-guests-stage";

const EditTagsLink = React.createClass({
  getInitialState() {
    return {
      isModalOpen: false
    }
  },
  render() {
    const { postId, tags, showIcon, hideText } = this.props;
    const title = tags.length > 0 ? "Edit Tags" : "Tag Guests";
    return (
      <a href="#" onClick={this.toggleModal}>
        { showIcon &&
          <i className="icon-tag" />
        }
        {!hideText && title}
        <SimpleModal
          isOpen={this.state.isModalOpen}
          onCloseClick={this.toggleModal}
          modalClassName="edit-tags-modal"
          modalId="edit-tags-modal"
          centered={true}
        >
          <h1>{title}</h1>
          <form>
            <TagGuestsStage
              postId={postId}
              tagSearchVisible={true}
              showSubmitButton={true}
              showCancelButton={true}
              tags={tags}
              onTagsSubmitted={this.toggleModal}
              onCancel={this.toggleModal}
            />
          </form>
        </SimpleModal>
      </a>
    );

  },
  toggleModal(e) {
    e.preventDefault();
    this.setState({isModalOpen: !this.state.isModalOpen});
  }
});

export default EditTagsLink;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/edit-tags-link.es6